
import vue from '../../adapter-vue';

const { ref } = vue;

interface Props {
  title: string;
}
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['input-submit'],
  setup(props: Props, { emit }) {
    const disabled = ref<boolean>(false);
    const text = ref<string>('');

    const listItemClick = (): void => {
      disabled.value = true;
      emit('input-submit', text.value);
    };
    return {
      disabled,
      text,
      listItemClick,
      props,
    };
  },
};
